"use client";
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation,Trans  } from 'react-i18next';
const Redevelopment = () => {
    const { t } = useTranslation();
    return (
        <section className="lyt-section typ-pt-60 typ-pb-0" id="founders">
            {/* <div className="container">
                <div className="heading-wrapper typ-mb-100">
                    <div>
                        <h2
                            className="bs-heading typdblue mb-2"
                            data-aos="fade-in"
                            data-aos-delay="200"
                        >
                            Hear it from the founders
                        </h2>
                        <p
                            className="bs-para typgrey"
                            data-aos="fade-in"
                            data-aos-delay="300"
                        >
                            Driving forces of our company
                        </p>
                    </div>
                </div>
            </div> */}
            <div className="typ-blue-lyt">
                <div className="container">
                    <div className="row">
                        {/* <div className="col-lg-12">
                            <div className="typ-card-flexs">
                                <div className="bs-card typ-founder-card">
                                    <div className="card">
                                        <div>
                                            <h4 className="card-head">Shri Gautam Chatterjee, IAS (Retd)</h4>
                                            <p className="designation">Former chairman of MahaRERA</p>
                                            <p className="founder-info">At GRSF, we believe that success is more than just profits and revenue. We believe in building a sustainable and socially responsible business</p>
                                        </div>
                                        <div className="card-footer">
                                            <div className="icons-flex">
                                                <Link href="#">
                                                    <span className="icon icon-linkedin"></span>
                                                </Link>
                                                <Link href="#">
                                                    <span className="icon icon-twitter"></span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="bs-card typ-founder-card">
                                    <div className="card">
                                        <div>
                                            <h4 className="card-head">CA Ramesh Prabhu</h4>
                                            <p className="designation">chairman of Mahasewa</p>
                                            <p className="founder-info">At GRSF, we believe that success is more than just profits and revenue. We believe in building a sustainable and socially responsible business</p>
                                        </div>
                                        <div className="card-footer">
                                            <div className="icons-flex">
                                                <Link href="#">
                                                    <span className="icon icon-linkedin"></span>
                                                </Link>
                                                <Link href="#">
                                                    <span className="icon icon-twitter"></span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="bs-card typ-founder-card">
                                    <div className="card">
                                        <div>
                                            <h4 className="card-head">Dnyaneshwar Hadadare</h4>
                                            <p className="designation">Secretary</p>
                                            <p className="founder-info">At GRSF, we believe that success is more than just profits and revenue. We believe in building a sustainable and socially responsible business</p>
                                        </div>
                                        <div className="card-footer">
                                            <div className="icons-flex">
                                                <Link href="#">
                                                    <span className="icon icon-linkedin"></span>
                                                </Link>
                                                <Link href="#">
                                                    <span className="icon icon-twitter"></span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div className="heading-wrapper typ-mb-160">
                            <div>
                                <h2
                                    className="bs-heading typwhite mb-2"
                                    data-aos="fade-in"
                                    data-aos-delay="200"
                                >
                            {t('founderTitle')}
                                </h2>
                            </div>
                        </div>
                        <div className="typ-card-flexs typ-responsive-space typ-mb0">
                            <div className="bs-card typ-founder-card typ-small-card">
                                <div className="card">
                                    <h4 className="card-head">Shri Gautam Chatterjee, IAS (Retd)</h4>
                                    <p className="designation">Chairman - GRSF</p>
                                    <div className="icons-flex typ-mt-12">
                                        <Link href="#">
                                            <span className="icon icon-linkedin"></span>
                                        </Link>
                                        <Link href="#">
                                            <span className="icon icon-twitter"></span>
                                        </Link>
                                        <Link href="#">
                                            <span className="icon icon-mail"></span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="bs-card typ-founder-card typ-small-card">
                                <div className="card">
                                    <h4 className="card-head">CA Ramesh Prabhu</h4>
                                    <p className="designation">Vice Chairman - GRSF</p>
                                    <div className="icons-flex typ-mt-12">
                                        <Link href="#">
                                            <span className="icon icon-linkedin"></span>
                                        </Link>
                                        <Link href="#">
                                            <span className="icon icon-twitter"></span>
                                        </Link>
                                        <Link href="#">
                                            <span className="icon icon-mail"></span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="bs-card typ-founder-card typ-small-card">
                                <div className="card">
                                    <h4 className="card-head">Dnyaneshvar Hadadare</h4>
                                    <p className="designation">Secretary - GRSF</p>
                                    <div className="icons-flex typ-mt-12">
                                        <Link href="#">
                                            <span className="icon icon-linkedin"></span>
                                        </Link>
                                        <Link href="#">
                                            <span className="icon icon-twitter"></span>
                                        </Link>
                                        <Link href="#">
                                            <span className="icon icon-mail"></span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="bs-card typ-founder-card typ-small-card">
                                <div className="card">
                                    <h4 className="card-head">CA Shreyash Prabhu</h4>
                                    <p className="designation">Financial Consultant</p>
                                    <div className="icons-flex typ-mt-12">
                                        <Link href="#">
                                            <span className="icon icon-linkedin"></span>
                                        </Link>
                                        <Link href="#">
                                            <span className="icon icon-twitter"></span>
                                        </Link>
                                        <Link href="#">
                                            <span className="icon icon-mail"></span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="bs-card typ-founder-card typ-small-card">
                                <div className="card">
                                    <h4 className="card-head">Vasant Wani</h4>
                                    <p className="designation">Technical Consultant</p>
                                    <div className="icons-flex typ-mt-12">
                                        <Link href="#">
                                            <span className="icon icon-linkedin"></span>
                                        </Link>
                                        <Link href="#">
                                            <span className="icon icon-twitter"></span>
                                        </Link>
                                        <Link href="#">
                                            <span className="icon icon-mail"></span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="bs-card typ-founder-card typ-small-card">
                                <div className="card">
                                    <h4 className="card-head">Adv. Kiran Saha Jadhav</h4>
                                    <p className="designation">Legal Consultant</p>
                                    <div className="icons-flex typ-mt-12">
                                        <Link href="#">
                                            <span className="icon icon-linkedin"></span>
                                        </Link>
                                        <Link href="#">
                                            <span className="icon icon-twitter"></span>
                                        </Link>
                                        <Link href="#">
                                            <span className="icon icon-mail"></span>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Redevelopment;
